import './style.css';

import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import PureRenderMixin from '../../../mixins/pure-render-mixin';
import Field from './field';
import StarInput from './star-input';

export default createReactClass({
  displayName: 'field-star-number',
  mixins: [PureRenderMixin],
  onChange(value) {
    this.props.onChange(value);
  },
  render() {
    const { onChange, onStarChange, dataTestId, ...other } = this.props;

    return (
      <Field
        label={this.props.label}
        managed={true}
        liveOnChange={true}
        errorStyle={{ top: -10 }}
        {...other}
        inputComponent={StarInput}
        spreadToInputComponent={{ onStarChange, dataTestId }}
        onChange={this.onChange}
      />
    );
  }
});
